import React from 'react'
import { View, StyleSheet } from "@react-pdf/renderer"
import Column from '../../../../../../../components/PDF/Column'

const TableRow: React.FC <any> = props => {

    const styles = StyleSheet.create({
        row: {
            flexDirection: "row",
            alignItems: "stretch",
            width: "100%",
        }
    })

    return(

        <View style = {styles.row} wrap={false}>
            <Column text = {''} width = "5%" />
            <Column text = {props.nome} align = "left" width = "40%" />
            <Column text = {props.mediaAnterior===null? "Não possui":props.mediaAnterior} width = "15%" />
            <Column text = {props.mediaAtual} width = "15%" />
            <Column text = {props.qtdeAmostra } width = "10%" />
            <Column text = {''} width = "15%" last />
        </View>

    )

}
export default TableRow